import { DefaultValue, selector, selectorFamily } from 'recoil';
import { CommunicationTypeEnum, CountryCallingCodeEnum, } from '@zurich/api/party';
import { localPartyCommunicationChannelAtomFamily } from '../atoms/localParty';
import { setHousenumberFrom, setHousenumberToMoreParts, setHousenumberToOnePart, } from './localParty';
export const localPartyCommunicationChannelCommunicationRoleSelectorFamily = selectorFamily({
    key: 'local/partyCommunicationChannel/communicationRole',
    get: (communicationChannelType) => ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        return communicationChannel?.communicationRole;
    },
    set: (communicationChannelType) => ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        set(localPartyCommunicationChannelAtomFamily(communicationChannelType), {
            ...communicationChannel,
            communicationRole: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelCountryCallingCodeSelector = selector({
    key: 'local/partyCommunicationChannel/countryCallingCode',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        return communicationChannel.countryCallingCode || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE), {
            ...communicationChannel,
            countryCallingCode: value instanceof DefaultValue || value === null
                ? CountryCallingCodeEnum.C43
                : value,
        });
    },
});
export const localPartyCommunicationChannelAreaCodeSelector = selector({
    key: 'local/partyCommunicationChannel/areaCode',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        return communicationChannel.areaCode || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE), {
            ...communicationChannel,
            areaCode: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelCommunicationPhoneNumberSelector = selector({
    key: 'local/partyCommunicationChannel/localPhoneNumber',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        return communicationChannel.localPhoneNumber || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.TELEPHONE), {
            ...communicationChannel,
            localPhoneNumber: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelEmailAddressSelector = selector({
    key: 'local/partyCommunicationChannel/emailAddress',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.EMAIL));
        return communicationChannel?.emailAddress;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.EMAIL));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.EMAIL), {
            ...communicationChannel,
            emailAddress: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelCommunicationPurposeSelectorFamily = selectorFamily({
    key: 'local/partyCommunicationChannel/communicationPurpose',
    get: (communicationChannelType) => ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        return communicationChannel?.communicationPurpose || null;
    },
    set: (communicationChannelType) => ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        set(localPartyCommunicationChannelAtomFamily(communicationChannelType), {
            ...communicationChannel,
            communicationPurpose: value instanceof DefaultValue || value === null
                ? undefined
                : value,
        });
    },
});
export const localPartyCommunicationChannelCountrySelectorFamily = selectorFamily({
    key: 'local/partyCommunicationChannel/country',
    get: (communicationChannelType) => ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        return communicationChannel?.country || null;
    },
    set: (communicationChannelType) => ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        set(localPartyCommunicationChannelAtomFamily(communicationChannelType), {
            ...communicationChannel,
            country: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelPostalCodeSelectorFamily = selectorFamily({
    key: 'local/partyCommunicationChannel/postalCode',
    get: (communicationChannelType) => ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        return communicationChannel?.postalCode || null;
    },
    set: (communicationChannelType) => ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        set(localPartyCommunicationChannelAtomFamily(communicationChannelType), {
            ...communicationChannel,
            postalCode: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelCitySelectorFamily = selectorFamily({
    key: 'local/partyCommunicationChannel/city',
    get: (communicationChannelType) => ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        return communicationChannel?.city || null;
    },
    set: (communicationChannelType) => ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(communicationChannelType));
        set(localPartyCommunicationChannelAtomFamily(communicationChannelType), {
            ...communicationChannel,
            city: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelStreetSelector = selector({
    key: 'local/partyCommunicationChannel/street',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        return communicationChannel?.street || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO), {
            ...communicationChannel,
            street: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelHouseNumberSelector = selector({
    key: 'local/partyCommunicationChannel/houseNumber',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        return communicationChannel?.houseNumber || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO), {
            ...communicationChannel,
            houseNumber: value instanceof DefaultValue ? null : value,
        });
    },
});
// when housenumber is "1-5" it get splittet in to parts (from => 1/to => 5) with theese selectors
export const localPartyCommunicationChannelHouseNumberFromSelector = selector({
    key: 'local/partyCommunicationChannel/houseNumberFrom',
    get: ({ get }) => {
        const houseNumber = get(localPartyCommunicationChannelHouseNumberSelector);
        return houseNumber?.split('-').shift() || null;
    },
    set: ({ get, set }, value) => {
        const houseNumber = get(localPartyCommunicationChannelHouseNumberSelector);
        const houseNumberParts = houseNumber && houseNumber.split('-').filter((element) => element !== '');
        set(localPartyCommunicationChannelHouseNumberSelector, setHousenumberFrom(value, houseNumberParts));
    },
});
export const localPartyCommunicationChannelHouseNumberToSelector = selector({
    key: 'local/partyCommunicationChannel/houseNumberTo',
    get: ({ get }) => {
        const houseNumber = get(localPartyCommunicationChannelHouseNumberSelector);
        const houseNumberParts = houseNumber?.split('-');
        return houseNumberParts && houseNumberParts.length > 1
            ? houseNumberParts.pop() || null
            : null;
    },
    set: ({ get, set }, value) => {
        const houseNumber = get(localPartyCommunicationChannelHouseNumberSelector);
        const houseNumberParts = houseNumber && houseNumber.split('-');
        if (houseNumberParts && houseNumberParts.length > 1) {
            set(localPartyCommunicationChannelHouseNumberSelector, setHousenumberToMoreParts(value, houseNumber, houseNumberParts));
        }
        else {
            set(localPartyCommunicationChannelHouseNumberSelector, setHousenumberToOnePart(value, houseNumber));
        }
    },
});
export const localPartyCommunicationChannelStaircaseSelector = selector({
    key: 'local/partyCommunicationChannel/staircase',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        return communicationChannel?.staircase || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO), {
            ...communicationChannel,
            staircase: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelDoorNumberSelector = selector({
    key: 'local/partyCommunicationChannel/doorNumber',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        return communicationChannel?.doorNumber || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO), {
            ...communicationChannel,
            doorNumber: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelDeliveryNoticeSelector = selector({
    key: 'local/partyCommunicationChannel/deliveryNotice',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        return communicationChannel?.deliveryNotice || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.GEO), {
            ...communicationChannel,
            deliveryNotice: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyCommunicationChannelPoboxNumberSelector = selector({
    key: 'local/partyCommunicationChannel/poboxNumber',
    get: ({ get }) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.POSTBOX));
        return communicationChannel?.poboxNumber || null;
    },
    set: ({ get, set }, value) => {
        const communicationChannel = get(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.POSTBOX));
        set(localPartyCommunicationChannelAtomFamily(CommunicationTypeEnum.POSTBOX), {
            ...communicationChannel,
            poboxNumber: value instanceof DefaultValue ? null : value,
        });
    },
});
